import { Tooltip } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { useTaskStatusColor } from '../secure-portal/tasks/Task.hooks';
import { Task } from '../secure-portal/tasks/Task.interface';

const StyledDiv = styled.div`
  height: 10px;
  min-width: 10px;
  margin-bottom: 2.5px;
  border-radius: 100%;
`;

const TaskStatusDot: React.FC<{ task: Task }> = ({ task }) => {
  const { color, label } = useTaskStatusColor({ task });
  return (
    <Tooltip arrow title={label} placement='top'>
      <StyledDiv style={color} className='status-circle' />
    </Tooltip>
  );
};

export default TaskStatusDot;
